import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill'
import { SearchComponent } from './search.component';
import { DocumentViewComponent } from './document-view/document-view.component';
import { SearchRoutingModule } from './search-routing.module';
import { KeycloakAngularModule } from 'keycloak-angular';
import { MatIconModule } from '@angular/material/icon'; 
import { MatChipsModule } from '@angular/material/chips'; 
import { NoSanitizePipeModule } from 'src/app/pipes/no-sanitizer-pipe.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    QuillModule,
    SearchRoutingModule,
    QuillModule.forRoot(),
    KeycloakAngularModule,
    MatIconModule,
    MatChipsModule,
    NoSanitizePipeModule,
    MatProgressSpinnerModule,
  ],
  exports: [SearchComponent, DocumentViewComponent],
  declarations: [SearchComponent, DocumentViewComponent],
  providers: [],
})
export class SearchModule {}
